// alterado

import React from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import {
    SvgIconPatrimonioImobilizado,
    SvgIconRecursosFinanceiros,
    SvgIconSeguroVida,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    StepperPadrao
} from '../../../business-components/Stepper/Stepper'

import {
    calculaIdadesDataSimulacao,
} from '../cliente-form/ClienteService'

import {
    calculaTotaisPatrimonioImobilizado,
} from '../garantias-form/GarantiasServicePatrimonioImobilizado'

import {
    incluiRecursosFinanceirosFGTSContribuicaoReceitaMensalCLT,
    calculaTotaisRecursosFinanceiros,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    calculaTotaisSeguroVida,
} from '../seguroVida-form/SeguroVidaService'

import GarantiasFormPatrimonioImobilizado from '../garantias-form/GarantiasFormPatrimonioImobilizado'

import GarantiasFormRecursosFinanceiros from '../garantias-form/GarantiasFormRecursosFinanceiros'

import SeguroVidaForm from '../seguroVida-form/SeguroVidaForm'



const PatrimonioForm = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars, arquivoList }) => {
        
    const stepsSvgIcon = [
        SvgIconPatrimonioImobilizado,
        SvgIconRecursosFinanceiros,
        SvgIconSeguroVida,
    ]

    const steps = [
        LABEL.patrimonioImobilizado1aParte,
        LABEL.recursosFinanceiros1aParte,
        LABEL.seguroVida,
    ]

    const stepsTitle2 = [
        LABEL.patrimonioImobilizado2aParte,
        LABEL.recursosFinanceiros2aParte,
        '',
    ]

    const stepsContent = [
        <GarantiasFormPatrimonioImobilizado
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <GarantiasFormRecursosFinanceiros
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            linhaTipoLicenca={vars.linhaTipoLicenca}
            //jsonConfiguracao={jsonConfiguracao}
        />,
        <SeguroVidaForm
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
    ]
    
    const valuesStepsTitle = [
        '',
        '',
        LABEL.morteQualquerCausa,
    ]

    const valuesStepsTitle2 = [
        '',
        '',
        LABEL.valorPremioTotal,
    ]

    incluiRecursosFinanceirosFGTSContribuicaoReceitaMensalCLT(values)

    if (values.stepPatrimonio.activeStep === 0) {

        calculaTotaisPatrimonioImobilizado(values)

    } else {

        if (values.stepPatrimonio.activeStep === 1) {

            calculaTotaisRecursosFinanceiros(values)

        } else {

            if (values.stepPatrimonio.activeStep === 2) {
                
                calculaTotaisSeguroVida(values)
            }
        }
    }

    useSingleton(async () => {

        calculaIdadesDataSimulacao(values, false)

        if (values.stepPatrimonio.activeStep !== 0) {

            calculaTotaisPatrimonioImobilizado(values)
        }

        if (values.stepPatrimonio.activeStep !== 1) {

            calculaTotaisRecursosFinanceiros(values)
        }

        if (values.stepPatrimonio.activeStep !== 2) {

            calculaTotaisSeguroVida(values)
        }
    })

    return (
        <ValidatorFormPadrao 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <StepperPadrao
                stepsType={"cardValor"}
                stepsSvgIcon={stepsSvgIcon}
                steps={steps}
                stepsTitle2={stepsTitle2}
                stepsContent={stepsContent}
                valuesStep={values.stepPatrimonio}
                valuesStepsTitle={valuesStepsTitle}
                valuesStepsValor={values.stepsValorPatrimonio}
                valuesStepsTitle2={valuesStepsTitle2}
                valuesStepsValor2={values.stepsValor2Patrimonio}
                naoPermiteConcluir={true}
            />
        </ValidatorFormPadrao>
    )
}

export default PatrimonioForm